var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#logo-cgf-baseline';
                    var viewUrl = 'sprite.svg#view-logo-cgf-baseline';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 198 107',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };